import React from "react"

import classnames from "classnames"

const Footer = props => {
  return (
    <>
      {/* <div className={classnames("footer",{
          "pvp": ['/pvp','/pvp/tournaments','/pvp/tournament_history','/pvp/tournament_active','/pvp/decks'].includes(window.location.pathname),
          "battle":window.location.pathname === '/pvp/battle',
          "tournament":['/pvp/tournaments','/pvp/tournament_history','/pvp/tournament_active','/pvp/decks'].includes(window.location.pathname),
      })}>
      </div> */}
      </>
  )
}

export default Footer
